import React from "react";

import { COUNTRY_LOCAL_STORAGE_KEY } from "@config/consts";
import { FOOTER } from "@config/testIds/footer";

import { AVAILABLE_COUNTRIES } from "@typings/globals";

import { Link } from "@components/Navigation/Link";

import { TestWrapper } from "@ui/Atoms";

import { getCountriesList } from "@services/Localisation";
import { setCountryInUrl } from "@services/SetCountryInUrl";

import { useTranslate } from "@hooks/useTranslate";
import { useLocalisation } from "@hooks/useLocalisation";
import { useBreakpoint } from "@hooks/useBreakpoint";

import * as Styled from "./CountriesList.styled";

const COUNTRY_SORT_ORDER = [
  AVAILABLE_COUNTRIES.AT,
  AVAILABLE_COUNTRIES.BE,
  AVAILABLE_COUNTRIES.CH,
  AVAILABLE_COUNTRIES.DE,
  AVAILABLE_COUNTRIES.FR,
  AVAILABLE_COUNTRIES.LU,
  AVAILABLE_COUNTRIES.NL,
  AVAILABLE_COUNTRIES.PL,
  AVAILABLE_COUNTRIES.IT,
  AVAILABLE_COUNTRIES.UK,
  AVAILABLE_COUNTRIES.US,
];

export const CountriesList = () => {
  const breakpoint = useBreakpoint();
  const translate = useTranslate();
  const { language, setCountry } = useLocalisation();
  const isMobile = breakpoint.mobile || breakpoint.tablet;

  const countries = getCountriesList(translate).sort(
    (a, b) =>
      COUNTRY_SORT_ORDER.indexOf(a.value) - COUNTRY_SORT_ORDER.indexOf(b.value),
  );

  const handleSetCountry = (country: AVAILABLE_COUNTRIES) => {
    setCountry(country);

    const setCountryInLocalStorage = (country: AVAILABLE_COUNTRIES) =>
      localStorage.setItem(COUNTRY_LOCAL_STORAGE_KEY, country);

    setCountryInUrl(country, language, isMobile, setCountryInLocalStorage);
  };

  return (
    <Styled.Languages>
      {countries.map(country => (
        <TestWrapper
          key={country.value}
          testId={`${FOOTER.COUNTRY_SELECT_OPTION}_${country.value}`}
        >
          <Link
            $style="medium_18"
            onClick={() => {
              handleSetCountry(country.value);
            }}
          >
            {country.label}
          </Link>
        </TestWrapper>
      ))}
    </Styled.Languages>
  );
};
